import { jsx as i } from "react/jsx-runtime";
import { al as t } from "../../vendor-EQDp64ng.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as o } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index26.css';const r = "_fieldDescription_a4zry_1", n = {
  fieldDescription: r
};
function f(e) {
  return e.children ? /* @__PURE__ */ i(
    t,
    {
      ...o(e),
      slot: "description",
      elementType: "span",
      className: n.fieldDescription,
      "data-component": "FieldDescription"
    }
  ) : null;
}
export {
  f as FieldDescription
};
